import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';
import { CURRENCY } from '../../environments/environment';
import {
  RATE_TYPE_FIXED, RATE_TYPE_PER_MONTH,
   RATE_TYPE_FREE, RATE_TYPE_PER_CLASS, RATE_TYPE_PER_HOUR,INACTIVE_STATUS,STATUS_INACTIVE,
   ACTIVE_STATUS,STATUS_ACTIVE,STATUS_DELETE,STATUS_DELETED,SUSPEND_STATUS,STATUS_SUSPENDED,
   STATUS_COMPLETE,COMPLETE_STATUS,CANCEL_STATUS,STATUS_CANCELLED,BATCH_STATUS_DELETE,BATCH_STATUS_DELETED
 
} from 'src/app/constants';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-d-cls-dtls',
  templateUrl: './d-cls-dtls.component.html',
  styleUrls: ['./d-cls-dtls.component.scss']
})
export class DClsDtlsComponent implements OnInit {

  scheduleID:any;
  pkgID:any;
  courseStatus:string;
  courseDetails:any;
  course_schedule:any;
  faculty:any;
  package_contents:any;
  vendorType:string;
  vendorTypeList:any;
  vendorTypeName:string;
  vendorTypeId:string;
  vendorTypes:number;
  specialityList:any;
  speciality:string;
  specialityName:string;
  ageGroup:string;
  batchName:string;
  occuranceType:string;
  startDate:string;
  endDate:string;
  startTime:string;
  endTime:string;
  numberOfHours:string;
  priceRateTypeName:string;
  priceRateTypeId:string;
  whatsappURL:string;
  deliveryMode:string;
  instructionChannel:string;
  joining:string;
  courseName:string;
  lowPrice:string;
  highPrice:string;
  registrationCharges:string;
  userID:string;
  description:string;
  package_features:any;
  businessName:string;
  vendorID:string;
  currency:string;
  courseID:string;
  category:string;
  coursePriceId:string;
  vendorId:string;
  businessDetailsList:[];
  contactNo:string;
  whatsAppno:string;
  profileDesc:string;
  experience:string;
  qualification:string;
  isTeacher:string;
  addressLineOne:string;
  addressLineTwo:string;
  venGroupTypes:string;
  status:string;
  country:string;
  countryState:string;
  postalCode:string;
  town:string;
  vendor_classes:any;
  socialmedia:string;
  closeResult:string;
  vendorClasses:any;
  facebookpage:string;
  linkedinpage:string;
  instapage:string;
  twitterPage:string;
  active:string;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private helperService:HelperService,
    private modalService: NgbModal) {
      this.scheduleID = this.activatedRoute.snapshot.paramMap.get('scheduleId');  
      this.pkgID = this.activatedRoute.snapshot.paramMap.get('packageId');
     

     }

  ngOnInit() {
    this.userID = this.helperService.getUserID();
    if(this.userID==null){
      this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`classDetails/`+ this.pkgID + `/` + this.scheduleID);
    }
    this.currency = CURRENCY;  

    let packageData = {
      //token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      courseID: this.pkgID,
      scheduleID: this.scheduleID,      
    }

    this.apiService.studentCourseDetails(packageData).subscribe((res:any)=>{          
      this.courseDetails = res.data.courseDetails.data.courseDetails[0];      
      this.course_schedule = res.data.courseDetails.data.course_schedule;
      this.faculty = res.data.courseDetails.data.faculty;
      this.package_contents = res.data.courseDetails.data.package_contents;
      this.package_features = res.data.courseDetails.data.package_features;

      

      this.getVendorType();
      this.getSpecilityType();


      this.vendorTypes = res.data.courseDetails.data.courseDetails[0].vendorTypes;    
      
      this.speciality = res.data.courseDetails.data.courseDetails[0].speciality;
      this.ageGroup = res.data.courseDetails.data.courseDetails[0].ageGroup;

      this.vendorId = res.data.courseDetails.data.courseDetails[0].vendorId;
      

      this.courseName = res.data.courseDetails.data.courseDetails[0].packageName;
      this.courseID = res.data.courseDetails.data.courseDetails[0].id;
      this.lowPrice =  res.data.courseDetails.data.courseDetails[0].lowPrice;
      this.highPrice = res.data.courseDetails.data.courseDetails[0].highPrice;
      this.registrationCharges = res.data.courseDetails.data.courseDetails[0].registrationCharges;      
      this.courseStatus =  res.data.courseDetails.data.courseDetails[0].status;
      this.description = res.data.courseDetails.data.courseDetails[0].description;
      this.businessName = res.data.courseDetails.data.courseDetails[0].businessName;
      this.coursePriceId = res.data.courseDetails.data.courseDetails[0].priceRateTypeId;

    
      this.batchName = res.data.courseDetails.data.course_schedule[0].batchName;
     
      
      if(this.occuranceType){
      this.occuranceType = res.data.courseDetails.data.course_schedule[0].occuranceType;
      }
      if(this.startDate){
      this.startDate = res.data.courseDetails.data.course_schedule[0].startDate;
      }
      if(this.endDate){
      this.endDate = res.data.courseDetails.data.course_schedule[0].endDate;
      }
      if(this.startTime){
      this.startTime = res.data.courseDetails.data.course_schedule[0].startTime;
      }
      if(this.endTime){
      this.endTime = res.data.courseDetails.data.course_schedule[0].endTime;
      }
      if(this.numberOfHours){
      this.numberOfHours = res.data.courseDetails.data.course_schedule[0].numberOfHours;
      }
      if(this.priceRateTypeName){
      this.priceRateTypeName = res.data.courseDetails.data.course_schedule[0].priceRateTypeName;
      }
      if(this.whatsappURL){
      this.whatsappURL = res.data.courseDetails.data.course_schedule[0].whatsappURL;
      }
      if(this.deliveryMode){
      this.deliveryMode = res.data.courseDetails.data.course_schedule[0].deliveryMode;
      }
      if(this.instructionChannel){
      this.instructionChannel = res.data.courseDetails.data.course_schedule[0].instructionChannel;
      }
      if(this.joining){
      this.joining = res.data.courseDetails.data.course_schedule[0].joining;
      }
      if(this.priceRateTypeId){
      this.priceRateTypeId = res.data.courseDetails.data.course_schedule[0].priceRateTypeId;      
      }
     
      this.status = res.data.courseDetails.data.course_schedule[0].status;
               

      this.package_features = res.data.courseDetails.data.package_features;
      this.package_contents = res.data.courseDetails.data.package_contents;

      let businessdata = {
        token:this.helperService.getToken(),
        userID:this.helperService.getUserID()  ,
        vendorID:this.vendorId
      }
  
      this.apiService.businessDetails(businessdata).subscribe((res:any)=>{       
      this.businessDetailsList = res.data.vendorBusinessDetails.data;
      this.deliveryMode =  res.data.vendorBusinessDetails.data.deliveryMode;
      
      this.contactNo = res.data.vendorBusinessDetails.data.venPhoneNumber;
      this.whatsAppno = res.data.vendorBusinessDetails.data.venAlternatePhoneNumber;
      this.profileDesc = res.data.vendorBusinessDetails.data.profileDescription;
      this.experience  = res.data.vendorBusinessDetails.data.experience;
      this.qualification = res.data.vendorBusinessDetails.data.qualification;
      this.businessName = res.data.vendorBusinessDetails.data.businessName;

      this.socialmedia = res.data.vendorBusinessDetails.data.facebookPage;

      this.vendor_classes = res.data.vendorBusinessDetails.data.vendor_classes;
      this.isTeacher = res.data.vendorBusinessDetails.data.isTeacher;
      this.addressLineOne = res.data.vendorBusinessDetails.data.address.addressLineOne;
      this.addressLineTwo = res.data.vendorBusinessDetails.data.address.addressLineTwo;
      this.addressLineTwo = res.data.vendorBusinessDetails.data.address.addressLineTwo;
      this.country = res.data.vendorBusinessDetails.data.address.country;
      this.countryState = res.data.vendorBusinessDetails.data.address.countryState;
      this.postalCode = res.data.vendorBusinessDetails.data.address.postalCode;
      this.town = res.data.vendorBusinessDetails.data.address.town;

      this.venGroupTypes = this.helperService.groupBy(res.data.vendorBusinessDetails.data.vendor_type_specialities, 'vendorTypeName');   
      

      this.facebookpage = res.data.vendorBusinessDetails.data.facebookPage;  
      this.linkedinpage = res.data.vendorBusinessDetails.data.linkedInPage;
      this.instapage =   res.data.vendorBusinessDetails.data.instagramPage;
      this.twitterPage = res.data.vendorBusinessDetails.data.twitterPage;

      if (this.vendor_classes) {
        let venClasses = [];
        for (const key in this.vendor_classes) {
          if (this.vendor_classes.hasOwnProperty(key)) {
            const element = this.vendor_classes[key];
            venClasses.push(element.className)
          }
        }
        this.vendorClasses = venClasses.join(' | ');
      }
      

      },async err => {

      })


    }, async err => {
        
    })

  }
  

  getStatus(status) {
    if (status === INACTIVE_STATUS) {
      return STATUS_INACTIVE;
    } else if (status === ACTIVE_STATUS) {
      return STATUS_ACTIVE;
    } else if (status === STATUS_DELETE) {
      return STATUS_DELETED;
    }
  }

  getBatchStatus(status) {
    if (status === ACTIVE_STATUS) {
      return STATUS_ACTIVE;
    } else if (status === SUSPEND_STATUS) {
      return STATUS_SUSPENDED;
    } else if (status === STATUS_COMPLETE) {
      return COMPLETE_STATUS;
    } else if (status === CANCEL_STATUS) {
      return STATUS_CANCELLED;
    } else if (status === BATCH_STATUS_DELETE) {
      return BATCH_STATUS_DELETED;
    }
  }

  getVendorType(){

    let vendorTypeData = {
      token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      courseID: this.pkgID,
      scheduleID: this.vendorID,
      pkgID: this.pkgID
     }
  
    this.apiService.getVenDetails(vendorTypeData).subscribe((res:any)=>{      
       this.vendorTypeList = res.data.venDetails.data;     
      this.vendorTypeList.forEach(obj => {             
       if( this.vendorTypes == obj.id  ){
          this.vendorTypeName = obj.vendorTypeName;   
          
                
       }  
                
      })      

    }, async err => {

    })

  }

  getSpecilityType(){
    let specialityData = {
      token: this.helperService.studented_atob(this.helperService.getToken()),
      userID: this.helperService.studented_atob(this.helperService.getUserID()),
      hostID: this.helperService.studented_atob(this.helperService.getHostID()),
      courseID: this.pkgID,
      scheduleID: this.vendorID,
      pkgID: this.pkgID
    }
    this.apiService.getSpecialityData(specialityData).subscribe((res:any)=>{    
     
      this.specialityList = res.data.specialityData.data;
      this.specialityList.forEach(obj1 => {                   
        if(this.speciality == obj1.id ){
           this.specialityName = obj1.specialityName;  
        }  
            
       })      
    }) 


  }

  getRateText(priceRateTypeId) {
    if (!priceRateTypeId) {
      return "";
    }

    if (priceRateTypeId === 1) {
      return RATE_TYPE_FIXED;
    } else if (priceRateTypeId === 2) {
      return RATE_TYPE_PER_MONTH;
    }
    else if (priceRateTypeId === 3) {
      return RATE_TYPE_FREE;
    }
    else if (priceRateTypeId === 4) {
      return RATE_TYPE_PER_CLASS;
    }
    else
      return RATE_TYPE_PER_HOUR;
  }

  
  request(vendorID,courseID){

   
    this.userID = localStorage.getItem(`userID`);
    
    if(this.userID==null){
      this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`create-enquiry/`+ vendorID + `/` +courseID );
    }
    
  }

  open(content) {
    this.modalService.open(content, {centered: true}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



}

